export default __webpack_public_path__ + "static/media/milk tea-normal.95052535.ttf";